import { render, staticRenderFns } from "./BrandEdit.vue?vue&type=template&id=3ee5610d&scoped=true&"
import script from "./BrandEdit.vue?vue&type=script&lang=js&"
export * from "./BrandEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee5610d",
  null
  
)

export default component.exports